import AxiosClient from './AxiosClient';
import { getHeaders } from './HttpUtil';

import type { IAuthorizationRequest, ICurrencyRequest, IPriceRequest } from '../../types/IApiTypes';
import type { IPackageDetails } from '../../types/ITypes';

export const PriceApi = {
  price: (action: IPriceRequest) => {
    const productCode = action.modelId;
    return AxiosClient.post(
      '/product/v1/price/read',
      {
        productCode: productCode,
        country: action.countryCode,
        currency: action.currencyCode,
        packageType: action.packageType,
        packageCode: action.packageCode,
      },
      { headers: getHeaders(action.token).headers }
    )
      .then((response) => {
        return {
          price: response.data,
          modelId: productCode,
        };
      })
      .catch(() => {
        throw new Error('Failed to fetch price data');
      });
  },

  currency: (action: ICurrencyRequest) => {
    return AxiosClient.post(
      '/product/v1/currency/read',
      {
        packageCode: action.packageCode,
        country: action.countryCode,
        packageType: action.packageType,
      },
      { headers: getHeaders(action.token).headers }
    )
      .then((response) => {
        return {
          currency: response.data,
        };
      })
      .catch(() => {
        return null;
      });
  },

  priceListMap: (action: IAuthorizationRequest & IPackageDetails) => {
    return AxiosClient.post(
      '/product/v1/pricelist/read',
      {
        packageCode: action.packageCode,
        packageType: action.packageType,
      },
      { headers: getHeaders(action.token).headers }
    )
      .then((response) => {
        return response.data.priceMaps;
      })
      .catch(() => {
        return null;
      });
  },
};
